import { useState } from "react";
import { useAuth } from "../../auth/AuthContext";
import { apiError } from "../../lib/api";
import Seo from "../../components/Seo";
import { LOGO } from "../../data/content";

export default function AdminLogin() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(email, password);
      window.location.href = "/admin";
    } catch (err) {
      setError(apiError(err, "Login failed."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-screen flex items-center justify-center bg-[#0A0A0E] px-4" data-testid="admin-login-page">
      <Seo title="Admin" noindex />
      <form onSubmit={submit} className="w-full max-w-sm rounded-2xl border border-white/10 bg-[#181824] p-8" data-testid="admin-login-form">
        <img src={LOGO} alt="Laugh at L.A. logo" className="mx-auto h-16 w-16 object-contain" />
        <h1 className="mt-4 text-center font-display text-3xl text-white">Backstage Login</h1>
        <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
          placeholder="Email" aria-label="Email" data-testid="admin-login-email"
          className="mt-8 w-full rounded-xl border border-white/15 bg-black/40 px-5 py-3.5 text-white placeholder-gray-500 outline-none focus:border-[#F59E0B]" />
        <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
          placeholder="Password" aria-label="Password" data-testid="admin-login-password"
          className="mt-4 w-full rounded-xl border border-white/15 bg-black/40 px-5 py-3.5 text-white placeholder-gray-500 outline-none focus:border-[#F59E0B]" />
        {error && <p role="alert" className="mt-3 text-sm text-red-400" data-testid="admin-login-error">{error}</p>}
        <button type="submit" disabled={loading} data-testid="admin-login-submit"
          className="mt-6 w-full rounded-full bg-[#E11D48] px-6 py-3.5 font-semibold text-white hover:bg-[#F43F5E] disabled:opacity-60">
          {loading ? "Signing in…" : "Sign In"}
        </button>
      </form>
    </main>
  );
}
